export default __webpack_public_path__ + "static/logo-87e56e4b8d16eea97e3c788eceda9f67.jpg";